<template>
  <div>
    <el-form :inline="true">
      <el-form-item prop="start_date">
        <el-date-picker
          style="width:200px"
          size="small"
          v-model="searchForm.start_date"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          :clearable="false"
        ></el-date-picker>
        <span> -</span>
      </el-form-item>
      <el-form-item prop="end_date">
        <el-date-picker
          style="width:200px"
          size="small"
          v-model="searchForm.end_date"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :clearable="false"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="操作员"
          v-model="searchForm.operator"
          size="small"
          clearable
          filterable
        >
          <el-option v-for="(item,index) in $store.state.operatorList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="产品名称"
          v-model="searchForm.product_name"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.productNameList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="产品规格"
          v-model="searchForm.product_size"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.productSizeList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="加工步骤"
          v-model="searchForm.process"
          size="small"
          clearable
          filterable
        >
          <el-option v-for="(item,index) in $store.state.processesList" :key="index" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          placeholder="生产单位"
          v-model="searchForm.department"
          size="small"
          clearable
          filterable
        >
          <el-option v-for="(item,index) in $store.state.departmentList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="searchForm.page = 1;getList()"
        >搜索</el-button>
      </el-form-item>
    </el-form>
    <el-row style="margin-bottom:15px">
      <el-button type="success" @click="goPrint()" size="small">打印所选</el-button>
      <el-button style="float:right" size="small" icon="el-icon-download" @click="getExcelPath">另存为Excel</el-button>
    </el-row>
    <el-alert type="success" :closable="false" style="margin-bottom:15px">
      <div slot="title">
        <span style="line-height:35px">已选日报:</span>
        <span v-if="selectList.length === 0">无</span>
        <span v-else>
          <el-tag
            @close="$refs.produceReportTable.toggleRowSelection(item)"
            closable
            type="success"
            style="margin-right:10px"
            v-for="(item, index) in selectList"
            :key="item.id"
          >{{` ${index+1}、${item.produce_date}:${item.operator}(${item.product_name}${item.product_size}) `}}</el-tag>
          <el-tag
            type="primary"
            style="margin-right:10px;cursor:pointer"
            @click="$refs['produceReportTable'].clearSelection()"
          >清空</el-tag>
        </span>
      </div>
    </el-alert>
    <el-table
      ref="produceReportTable"
      :data="reportTableList"
      border
      highlight-current-row
      v-loading="tableLoading"
      @sort-change="sortChange"
      @selection-change="(selection)=>{selectList=selection}"
      @row-click="row=>{$refs.produceReportTable.toggleRowSelection(row)}"
      :row-key="row=>row.id"
      :show-summary="$store.state.forbiddenAccess.indexOf('2') === -1"
      :summary-method="sumMethod"
    >
      <el-table-column :reserve-selection="true" type="selection" align="center"></el-table-column>
      <el-table-column
        prop="produce_date"
        label="日期"
        align="center"
        width="103px"
        sortable="custom"
      ></el-table-column>
      <el-table-column prop="operator" label="操作员" align="center" sortable="custom" min-width="90px"></el-table-column>
      <el-table-column prop="product_name" label="产品名称" align="center"></el-table-column>
      <el-table-column prop="product_size" label="产品规格" align="center" min-width="110px" sortable="custom"></el-table-column>
      <el-table-column prop="process" label="加工步骤" align="center"></el-table-column>
      <el-table-column prop="produce_hour" label="作业时间" align="center"></el-table-column>
      <el-table-column prop="produce_count" label="实际产量" align="center">
        <template slot-scope="scope">
          <div>{{isNaN(parseFloat(scope.row.produce_count)) ? '' :parseFloat(scope.row.produce_count)}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.price !== null && scope.row.price !== 0">{{scope.row.price}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="金额" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.price !== null && parseFloat(scope.row.price) !== 0 && showMoney(scope)">{{isNaN(parseFloat(scope.row.money)) ? '' :parseFloat(scope.row.money)}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="department" label="生产单位" align="center" min-width="110px" sortable="custom"></el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        align="center"
        width="103px"
        sortable="custom"
      ></el-table-column>
      <el-table-column prop="remark" label="备注" align="center"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160px">
        <template slot-scope="scope">
          <el-link :disabled="disabledOperate(scope.row.is_pass)" type="primary" @click.stop="showEdit(scope.row)">编辑</el-link>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm
            v-if="!disabledOperate(scope.row.is_pass)"
            confirmButtonText="确认"
            cancelButtonText="取消"
            icon="el-icon-warning-outline"
            iconColor="red"
            title="确定删除吗？"
            @click.native="(e)=>{e.stopPropagation()}"
            @onConfirm="deleteProduceReport(scope.row.id)"
          >
            <el-link slot="reference" type="primary">删除</el-link>
          </el-popconfirm>
          <el-link type="primary" v-else disabled>删除</el-link>
          <el-divider v-if="$store.state.forbiddenAccess.indexOf('2') === -1" direction="vertical"></el-divider>
          <el-link v-if="$store.state.forbiddenAccess.indexOf('2') === -1 && !scope.row.is_pass" type="primary" @click.stop="passProduceReport(scope.row.id)">通过</el-link>
          <el-link v-if="$store.state.forbiddenAccess.indexOf('2') === -1 && scope.row.is_pass" type="success" disabled>已通过</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:15px"
      :total="reportTableTotal"
      :current-page.sync="searchForm.page"
      @current-change="(page)=>{this.searchForm.page = page;this.getList()}"
      @size-change="(size)=>{this.searchForm.pageSize = size;this.searchForm.page = 1;this.getList()}"
      :page-sizes="[10, 20, 50, 999999]"
      :page-size="50"
      layout="prev, pager, next, ->, total, sizes"
      align="center"
    ></el-pagination>
    <!-- 编辑产品对话框 -->
    <el-dialog
      :title="`编辑 (${editForm.product_name} ${editForm.product_size})`"
      :visible.sync="editVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form ref="editForm" :model="editForm" label-width="250px">
        <el-form-item label="日期" prop="produce_date">
          <el-date-picker
            style="width:200px"
            size="small"
            v-model="editForm.produce_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="操作员" prop="operator">
          <el-select
          placeholder="选择操作员"
          v-model="editForm.operator"
          size="small"
          clearable
          filterable
        >
          <el-option v-for="(item,index) in $store.state.operatorList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="生产单位" prop="department">
          <el-select
          placeholder="选择生产单位"
          v-model="editForm.department"
          size="small"
          clearable
          filterable
        >
          <el-option v-for="(item,index) in $store.state.departmentList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="产品名称" prop="product_name">
        <el-select
          v-model="editForm.product_name"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.productNameList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品规格" prop="product_size">
        <el-select
          v-model="editForm.product_size"
          size="small"
          clearable
          filterable
        >
          <el-option
            v-for="(item,index) in $store.state.productSizeList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="加工步骤" prop="process">
          <el-select style="width:200px" v-model="editForm.process" filterable clearable>
            <el-option
              v-for="(processItem,index) in $store.state.processesList"
              :key="index"
              :label="processItem.name"
              :value="processItem.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="作业时间"
          prop="produce_hour"
          :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
        >
          <el-input
            clearable
            style="width:200px"
            size="small"
            v-model="editForm.produce_hour"
            placeholder="请输入作业时间"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="实际产量"
          prop="produce_count"
          :rules="{ pattern: /^[0-9]*(\.[0-9]{1,3})?$/, message: '请输入数字(最多三位小数)', trigger: 'blur' }"
        >
          <el-input
            clearable
            style="width:200px"
            size="small"
            v-model="editForm.produce_count"
            placeholder="请输入实际产量"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="单价"
          prop="price"
          :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
        >
          <el-input
            clearable
            style="width:200px"
            size="small"
            v-model="editForm.price"
            placeholder="请输入单价"
          ></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input
            size="small"
            v-model="editForm.remark"
            placeholder="备注"
            style="width:200px"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="editVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="editProduceReport">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getProduceReportList, deleteProduceReport, editProduceReport, createProduceReportExcel, passProduceReport } from '../api/index'
import { baseURL } from '../config/App'
// import { getRowspanArr } from '../assets/lib/utils'
export default {
  data () {
    return {
      tableLoading: false,
      searchForm: {
        start_date: new Date(new Date().getTime() - 86400000).format('yyyy-MM-dd'),
        end_date: new Date().format('yyyy-MM-dd'),
        product_name: '',
        product_size: '',
        operator: '',
        process: '',
        department: '',
        sortType: 'id',
        order: 'desc',
        page: 1,
        pageSize: 50
      },
      reportTableTotal: null,
      reportTableList: [],
      spanArr: [],
      selectList: [],
      editForm: {},
      editVisible: false
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    sortChange (sortInfo) {
      this.searchForm.sortType = sortInfo.prop
      if (sortInfo.order === 'ascending') {
        this.searchForm.order = 'asc'
      } else if (sortInfo.order === 'descending') {
        this.searchForm.order = 'desc'
      } else {
        this.searchForm.sortType = 'id'
        this.searchForm.order = 'desc'
      }
      this.searchForm.page = 1
      this.getList()
    },
    editProduceReport () {
      this.$refs['editForm'].validate(valid => {
        if (valid) {
          editProduceReport(this.editForm).then(res => {
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.editVisible = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    showEdit (current) {
      current = JSON.parse(JSON.stringify(current))
      delete current.create_time
      this.editForm = current
      this.editVisible = true
    },
    deleteProduceReport (id) {
      deleteProduceReport({ id }).then(res => {
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    goPrint () {
      if (this.selectList.length === 0) {
        this.$message.error('请至少选择一条记录')
        return
      }
      let routeData = this.$router.resolve({
        path: '/produceReportPrintPage',
        query: {
          dataList: JSON.stringify(this.selectList)
        }
      })
      window.open(routeData.href, '_blank')
    },
    getExcelPath () {
      this.$prompt('请输入文件名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        createProduceReportExcel(this.searchForm).then(res => {
          if (res.data.status === 200) {
            value || (value = '未命名')
            window.location.href = baseURL + '/index/getExcel?path=' + res.data.data + '&filename=' + value
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '下载失败'
        })
      })
    },
    getList () {
      this.tableLoading = true
      getProduceReportList(this.searchForm).then(res => {
        if (res.data.status === 200) {
          this.reportTableList = res.data.data
          this.reportTableTotal = res.data.total
          // this.spanArr = getRowspanArr(this.reportTableList, ['produce_date', 'operator'])
          this.tableLoading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    sumMethod ({ columns, data }) {
      let moneyArr = data.map(item => item.money)
      let moneySum = moneyArr.reduce((pre, cur) => {
        if (isNaN(parseFloat(cur))) {
          return pre
        } else {
          return parseFloat(pre) + parseFloat(cur)
        }
      }, 0)
      let sums = []
      sums[1] = '合计金额'
      sums[9] = moneySum.toFixed(2) + '元'
      return sums
    },
    showMoney (scope) {
      if (this.$store.state.forbiddenAccess.indexOf('2') !== -1) {
        let itemTime = new Date(scope.row.produce_date.replace('-', '/')).getTime()
        let todayTime = new Date(new Date().toLocaleDateString()).getTime()
        if ((todayTime - (86400000 * 1)) <= itemTime && itemTime <= todayTime) {
          return true
        }
      } else {
        return true
      }
      return false
    },
    disabledOperate (isPass) {
      if (this.$store.state.forbiddenAccess.indexOf('2') === -1 || !isPass) {
        return false
      }
      return true
    },
    passProduceReport (id) {
      passProduceReport({ id }).then(res => {
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style>
</style>
